<div class="bmc-line-chart__item bz-space--inset-m bz-space--stack-s bz-shadow--xs bz-border-radius--m  bz-space--inline-m">
    <canvas [id]="idChart"></canvas>
</div>